// extracted by mini-css-extract-plugin
export default {"typography":"index_typography__hjpax","block":"index_block__UPKeW"};